import axios from "axios";
import authHeader from './auth-header';

const API_BASE_URL = "https://sporteventmanagement.it/api"; // Cambia se il backend è in un'altra porta

export const getTimetable = async (competitionId) => {
  try {
    console.log("authHeader()", authHeader());
    const response = await axios.get(`${API_BASE_URL}/competitions/${competitionId}/timetable`, { headers: authHeader() });
    return response.data; // Restituisce una lista di DTO
  } catch (error) {
    console.error("Errore nel recupero del timetable:", error);
    throw error;
  }
};

export const saveTimetable = async (competitionId, timetableRows) => {
  try {
    await axios.post(`${API_BASE_URL}/competitions/${competitionId}/timetable`, timetableRows, { headers: authHeader() });
  } catch (error) {
    console.error("Errore nel salvataggio del timetable:", error);
    throw error;
  }
};

export const deleteTimetableRow = async (competitionId, id) => {
  await axios.delete(`${API_BASE_URL}/competitions/${competitionId}/timetable/delete/${id}`, { headers: authHeader() });
};

export const deleteTimetable = async (competitionId) => {
  const response = await fetch(`${API_BASE_URL}/competitions/${competitionId}/timetable/delete`, {
    method: 'DELETE',
    headers: authHeader()
  });
  if (!response.ok) throw new Error("Errore eliminazione timetable");
};
